import { render } from "./edittravel.vue?vue&type=template&id=3bc3d47c&scoped=true"
import script from "./edittravel.vue?vue&type=script&lang=js"
export * from "./edittravel.vue?vue&type=script&lang=js"

import "./edittravel.vue?vue&type=style&index=0&id=3bc3d47c&lang=scss&scoped=true"
import "./edittravel.vue?vue&type=style&index=1&id=3bc3d47c&scoped=true&lang=css"

import exportComponent from "D:\\workCode\\PC\\web-middleground\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bc3d47c"]])

export default __exports__